<template lang="pug">
.sv-select-input-list
    .sv-select-input-list__container(
        v-for="(value, index) in valuesWithEmpty"
        :key="index"
    )
        SvInput.sv-select-input-list__select(
            color="graylight"
            :value="value[firstInput]"
            :withIcon="false"
            @input="(v) => changeValueFirst(v, index)"
            placeholder="Например: Центр для фихтования"
        )

        SvInput.sv-select-input-list__inputcoords(
            color="graylight"
            :customMask="{regex: '^([-]?[0-9]{1,4})([.][0-9]{1,10})?([,] ([-]?[0-9]{1,4}))([.][0-9]{1,10})?$', placeholder: '', showMaskOnHover: false, showMaskOnFocus: false}"
            :value="value.coordinatesString"
            :withIcon="false"
            :class="{ 'sv-select-input-list--with-remove': value.coordinatesString || value[firstInput] || value[textInput] }"
            @input="(v) => changeCoordinatesInput(v, index)"
            @blur="(v) => changeCoordinatesBlur(v, index)"
            placeholder="Геокоординаты"
        )


        SvInput.sv-select-input-list__input(
            color="graylight"
            :value="value[textInput]"
            :withIcon="false"
            :class="{ 'sv-select-input-list--with-remove': value[textInput] || value[firstInput] }"
            @input="(v) => changeValueInput(v, index)"
            placeholder="Минут"
        )

        SvButton.sv-select-input-list__remove(
            v-if="value[textInput] || value[firstInput] || value.coordinatesString"
            icon
            :prependIcon=`{
                icon: 'trash',
                width: 20,
                height: 20,
                default: '#B7BAC6',
                hover: '#1993EB'
            }`
            view="primary-icon"
            @click="remove(index)"
        )
</template>

<script>
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvInput from '@/components/uikit/SvInput.vue';

export default {
  name: 'SvDoubleInputList',

  data() {
    return {
      latitude: '',
      longitude: '',
      coordinatesString: ''
    }
  },

  components: {
    SvSelect,
    SvButton,
    SvInput,
  },

  model: {
    prop: 'values',
    event: 'change',
  },

  props: {
    // Список всех значений
    values: {
      type: Array,
      required: true,
    },

    firstInput: {
      type: String,
      default: 'title',
    },

    textInput: {
      type: String,
      default: 'text',
    },
  },

  computed: {
    valuesWithEmpty() {
      return [...this.values, { [this.firstInput]: '', [this.textInput]: '' }];
    },
  },

  methods: {

    changeCoordinatesInput(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      copyValues.splice(index, 1, {
        ...currentValue,
        coordinatesString: value,
      });
      this.$emit('change', copyValues);
    },

    changeCoordinatesBlur(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      const coordinates = value.split(', ');

      copyValues.splice(index, 1, {
        ...currentValue,
        latitude: coordinates[0] || '',
        longitude: coordinates[1] || ''
      });
      this.$emit('change', copyValues);
    },



    changeValueInput(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      copyValues.splice(index, 1, {
        ...currentValue,
        [this.textInput]: value,
      });
      this.$emit('change', copyValues);
    },

    changeValueFirst(value, index) {
      const copyValues = [...this.values];
      const currentValue = copyValues[index];
      copyValues.splice(index, 1, {
        ...currentValue,
        [this.firstInput]: value,
      });
      this.$emit('change', copyValues);
    },

    remove(index) {
      const temp = this.values.slice();
      temp.splice(index, 1);
      this.$emit('change', temp);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-select-input-list__container {
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
}
.sv-select-input-list {
    &--with-remove {
        // margin-bottom: 15px;
    }

    &__container {
        display: flex;
    }

    &__select {
        width: 311px;
        margin-right: 10px;
    }

    &__input {
        width: 84px;
        margin-right: 10px;
    }

    &__inputcoords {
        width: 188px;
        margin-right: 10px;
    }
}
</style>
